export const TEMPLATE_HTML_KEYS = {
  COUNTRY_PREFIX: "${countryPrefix}"
};
